const API_URL = process.env.REACT_APP_API_URL;

class ShippingService {
  async getAddresses() {
    const response = await fetch(`${API_URL}/shipping`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch addresses');
    }

    return response.json();
  }

  async addAddress(addressData) {
    const response = await fetch(`${API_URL}/shipping`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(addressData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to add address');
    }

    return response.json();
  }

  async updateAddress(id, addressData) {
    const response = await fetch(`${API_URL}/shipping/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(addressData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to update address');
    }

    return response.json();
  }

  async deleteAddress(id) {
    const response = await fetch(`${API_URL}/shipping/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to delete address');
    }

    return response.json();
  }
}

const shippingService = new ShippingService();
export default shippingService;